var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"vacatures-deputatie"},_vm._l((_vm.categories.slice().splice(0, 5)),function(subCategory){return _c('li',{key:subCategory.CategoryID},[_c('router-link',{attrs:{"to":{
        path: `/catalogus/${_vm.parentCategorySlug}/${subCategory.Slug}`
      }}},[_vm._v(_vm._s(subCategory.Description))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }